<template>
  <div class="wrapper">
    <div v-for="(step, i) in steps"
      :class="{ active: i + 1 === active, done: stepDone(i) }"
      class="step"
    >
      <span class="label">
        <AppBadge
          :content="stepDone(i) ? '✔' : i + 1"
          color="#fff"
          inline
        />
        <span class="name">
          {{ step }}
        </span>
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  steps: string[];
  active: number;
}>();

function stepDone(i: number) {
  return i + 1 < props.active;
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 40px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  border-start-start-radius: inherit;
  border-start-end-radius: inherit;
  border-bottom: 1px #ccc solid;
  position: relative;
}
.step {
  width: 100%;
  height: 100%;
  text-align: center;
  color: #333;
  position: relative;

  &:first-child {
    border-start-start-radius: inherit;
    border-end-start-radius: inherit;
  }
  &:last-child {
    border-end-end-radius: inherit;
    border-start-end-radius: inherit;
  }

  .label {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: var(--space-2);
  }

  &.done, &.active {
    background-color: rgb(var(--v-theme-primary));
  }
  &.done .label {
    opacity: .75;
  }
  &.active, &.done {
    color: white;
  }
  &.active:not(:last-child) {
    &::after {
      content: '';
      height: 0;
      width: 0;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      position: absolute;
      inset-inline-end: -20px;
      top: 0;
      border-inline-start: 20px solid rgb(var(--v-theme-primary));
    }
  }
}
@media (max-width: 850px) {
  .step .label {
    font-size: 12px;
    line-height: 1;
    gap: 0;
    .v-badge {
      margin-inline-start: var(--space-2);
    }
  }
  .step:not(.active) .name {
    display: none;
  }
}
</style>